import api from './index'
import { axios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 * }
 * @param parameter
 * @returns {*}
 */
export function login () {
  return axios({
    url: api.Login,
    method: 'post'
  })
}

export function getInfo () {
  return axios({
    url: api.UserInfo,
    method: 'post'
  })
}

export function logout () {
  return axios({
    url: api.Logout,
    method: 'post'
  })
}
